var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSolidWallLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 256 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-4, .cls-5, .cls-6, .cls-7 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #e6e6e6;\r\n      }\r\n\r\n      .cls-4, .cls-5, .cls-6, .cls-7 {\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-width: 0.67px;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke-width: 0.33px;\r\n      }\r\n\r\n      .cls-6 {\r\n        stroke-width: 0.47px;\r\n      }\r\n\r\n      .cls-7 {\r\n        stroke-width: 0.8px;\r\n      }\r\n\r\n      .cls-8 {\r\n        font-size: 8.79px;\r\n        font-family: ArialMT, Arial;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.3,
    width: 233.41,
    height: 200
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconSolidWallLayer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundary"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 256,
    height: 200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Solid_Wall",
    "data-name": "Solid Wall"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "146.21 146.49 146.21 57.15 68.2 29.07 68.2 118.4 146.21 146.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "146.21 146.49 154.03 142.11 154.03 52.77 146.21 57.15 146.21 146.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "146.21 57.15 154.03 52.77 76.02 24.69 68.2 29.07 146.21 57.15"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 68.2,
    y1: 118.4,
    x2: 146.21,
    y2: 146.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 146.21,
    y1: 146.49,
    x2: 146.21,
    y2: 57.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 146.21,
    y1: 57.15,
    x2: 68.2,
    y2: 29.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 68.2,
    y1: 29.07,
    x2: 68.2,
    y2: 118.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 76.02,
    y1: 24.69,
    x2: 154.03,
    y2: 52.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 154.03,
    y1: 52.77,
    x2: 154.03,
    y2: 142.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 154.03,
    y1: 142.11,
    x2: 146.21,
    y2: 146.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 154.03,
    y1: 52.77,
    x2: 146.21,
    y2: 57.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 76.02,
    y1: 24.69,
    x2: 68.2,
    y2: 29.07
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 143.61,
    y1: 42.91,
    x2: 156.63,
    y2: 35.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 154.03,
    y1: 37.07,
    x2: 152.73,
    y2: 39.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 154.03,
    y1: 37.07,
    x2: 155.33,
    y2: 34.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 154.03,
    y1: 37.07,
    x2: 154.03,
    y2: 33.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 154.03,
    y1: 37.07,
    x2: 154.03,
    y2: 49.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 146.21,
    y1: 41.45,
    x2: 144.91,
    y2: 44.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 146.21,
    y1: 41.45,
    x2: 147.51,
    y2: 38.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 146.21,
    y1: 41.45,
    x2: 146.21,
    y2: 37.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 146.21,
    y1: 41.45,
    x2: 146.21,
    y2: 53.43
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.92 40.08 150.72 40.05 151.26 39.46 151.23 38.67 150.65 38.12 149.85 38.15 149.31 38.74 149.34 39.53 149.92 40.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "149.92 40.08 150.72 40.05 151.26 39.46 151.23 38.67 150.65 38.12 149.85 38.15 149.31 38.74 149.34 39.53 149.92 40.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "149.92 40.08 150.72 40.05 151.26 39.46 151.23 38.67 150.65 38.12 149.85 38.15 149.31 38.74 149.34 39.53 149.92 40.08"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 154.1,
    y1: 28.87,
    x2: 167.13,
    y2: 28.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 150.29,
    y1: 39.1,
    x2: 154.1,
    y2: 28.87
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(170.26 31.99)"
  }, "Thickness"), /*#__PURE__*/React.createElement("polygon", {
    points: "140.01 87.48 140.72 87.85 141.48 87.62 141.85 86.91 141.62 86.15 140.91 85.78 140.15 86.01 139.78 86.72 140.01 87.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "140.01 87.48 140.72 87.85 141.48 87.62 141.85 86.91 141.62 86.15 140.91 85.78 140.15 86.01 139.78 86.72 140.01 87.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "140.01 87.48 140.72 87.85 141.48 87.62 141.85 86.91 141.62 86.15 140.91 85.78 140.15 86.01 139.78 86.72 140.01 87.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 158.93,
    y1: 71.82,
    x2: 167.13,
    y2: 71.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 140.81,
    y1: 86.82,
    x2: 158.93,
    y2: 71.82
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(170.26 74.95)"
  }, "Material"), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(48.97 165.59)"
  }, "Note: Materials with GWP defined per unit "), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(48.97 175.66)"
  }, "area will not take thickness into account in "), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(48.97 185.72)"
  }, "calculations.")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolidWallLayer);
export default __webpack_public_path__ + "static/media/IconSolidWallLayer.7799c11923201230719edd4e50e70553.svg";
export { ForwardRef as ReactComponent };